import React from 'react'
import Style from './Content.css'
import SectionLabel from '../SectionLabel/SectionLabel'
import Button from '../Button/Button'
import one from '../../assets/What-We-Do-Image-1.jpg'
import two from '../../assets/What-We-Do-Image-2.jpg'
import three from '../../assets/What-We-Do-Image-3.jpg'
import four from '../../assets/What-We-Do-Image-4.jpg'

const What = () => {
  return (
    <section className="pt-10 pb-14 md:pt-20 bg-color-arizona-blue md:pb-20 what-container">
      <div className="container">
        <SectionLabel
          heading={'What We Do'}
          body={'Why wait to achieve great things? We’re ready for you now.'}
          styles={'text-white'}
        />
        <div className="flex max-md:flex-col-reverse pt-2">
          <div className="bullets-points md:pr-2 mt-14 md:max-w-[292px]">
            <div>
              <p className="text-2xl font-color-sky font-black condensed">WE SEEK</p>
              <p className="text-white italic md:pr-2">
                Dive into research as early as your first year.
              </p>
            </div>
            <div>
              <p className="text-2xl font-color-sky font-black pt-6 condensed">WE CONNECT</p>
              <p className="text-white italic">
                Make friends through mentorship, clubs, and a Common Reading program.
              </p>
            </div>
            <div>
              <p className="text-2xl font-color-sky font-black pt-6 condensed">WE CREATE</p>
              <p className="text-white italic">
                Customize your education with internships and other opportunities.
              </p>
            </div>
            <div>
              <p className="text-2xl font-color-sky font-black pt-6 condensed">WE EVOLVE</p>
              <p className="text-white italic">
                Giving back through service-learning is a cornerstone of your experience.
              </p>
            </div>
            <div>
              <p className="text-2xl font-color-sky font-black pt-6 condensed">WE CELEBRATE</p>
              <p className="text-white italic">
                Lean on professors, advisors, and peers who are cheering you on.
              </p>
            </div>
          </div>
          <div className="collage">
            <div className="flex max-md:flex-col  align-start">
              <div className="mt-14 pseudo-do-1">
                <img src={four} width="323" />
              </div>
              <div className="ml-10 mr-8 pseudo-do-2 h-fit">
                <img src={two} width="340" />
              </div>
            </div>
            <div className="flex max-md:flex-col">
              <div className="mt-12 ml-14 pseudo-do-3">
                <img src={three} width="340" />
              </div>
              <div className="ml-14 pseudo-do-4 h-fit">
                <img src={one} width="340" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex max-md:flex-col pt-4 justify-between md:mt-14">
          <div className="text-2xl font-extrabold text-white condensed">
            TOGETHER, WE ARE FRANKE HONORS WILDCATS
          </div>
          <div className="what-button-wrap">
            <Button
              linkId="your-community"
              className="border-white"
              link="https://frankehonors.arizona.edu/why-honors/honors-community"
            >
              Your Community
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default What
